import { InteractiveTable, ActionPanel as LuterkortActionPanel } from '@ingrid/luterkort-react';

import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { useToast } from '~src/main/hooks/useToast';

import { useAddressBookRemoveMutation } from '../mutations';

export function ActionPanel() {
  const removeMutation = useAddressBookRemoveMutation();

  const { selectionManager } = InteractiveTable.useContext();
  const { t } = useTranslation();
  const { toast } = useToast();

  const selected = selectionManager.getSelectedKeys();

  async function handleDelete() {
    const removePromise = removeMutation.mutateAsync({ contact_ids: selected });

    await toast.promise(removePromise, {
      success: { title: t('addressBook.delete.success') },
      error: { title: t('addressBook.delete.error') },
      loading: { title: t('addressBook.delete.loading') },
    });

    selectionManager.clearAll();
  }

  return (
    <LuterkortActionPanel.Root
      style={{
        width: '100%',
        maxWidth: '1008px',
      }}
    >
      <LuterkortActionPanel.Selection />

      <LuterkortActionPanel.Inline>
        <LuterkortActionPanel.DeselectAllButton />
      </LuterkortActionPanel.Inline>

      <LuterkortActionPanel.Actions>
        <RoleGuard roles={['transport:edit']} withTooltip>
          <LuterkortActionPanel.Button onClick={handleDelete}>{t('common.delete')}</LuterkortActionPanel.Button>
        </RoleGuard>
      </LuterkortActionPanel.Actions>
    </LuterkortActionPanel.Root>
  );
}
